import { put, select, takeLatest } from 'redux-saga/effects'

import { actionTypes } from '@signavio/kraken'

import { logout } from '../actions'
import { SessionSagaReturnType, isLoggedInSessionState } from '../../types'

interface Action {
  type: string
  payload?: { status?: number; error?: string }
}

const STATUS_UNAUTHORIZED = 401

export function* filterUnauthorizedRequest(
  action: Action
): SessionSagaReturnType {
  const session = yield select((state) => state.session)

  if (!isLoggedInSessionState(session)) {
    return
  }

  if (!session.token) {
    return
  }

  if (action.payload?.status === STATUS_UNAUTHORIZED) {
    if (
      action.payload.error === 'Accessing restricted org without SSO login.'
    ) {
      yield put(
        logout({
          mustLoginWithSPM: true,
        })
      )
    } else {
      yield put(logout())
    }
  }
}

export default function* watchRequestUnauthorized() {
  yield takeLatest(
    [
      actionTypes.CREATE_FAILURE,
      actionTypes.FETCH_FAILURE,
      actionTypes.UPDATE_FAILURE,
      actionTypes.REMOVE_FAILURE,
    ],

    filterUnauthorizedRequest
  )
}
